import React from 'react';
import { Avatar, ButtonBase } from '@mui/material';
import { useTheme } from "@mui/material/styles";

const UserIconButton = ({ avatar, name, handleClick }) => {

  const theme = useTheme();

  return (
    <ButtonBase aria-label="Account menu" onClick={handleClick}>
      <Avatar
        alt={name}
        variant="rounded"
        src={avatar || undefined}
        sx={{ backgroundColor: theme.palette.primary.main, textTransform: 'uppercase' }}
      >
        {name[0]}
      </Avatar>
    </ButtonBase>
  );
};

export default UserIconButton;
